import React, {Component, Fragment} from 'react';
import { Dialog, DialogActionsBar} from '@progress/kendo-react-dialogs';
import { Input } from '@progress/kendo-react-inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { connect } from 'react-redux';
import { fetchSubscriptionTypes, selectSubscriptionType } from '../../../../../Redux/Actions/Admin/ManageSubscriptionTypeActions';
import { fetchSubscriptionStatuses, fetchSubscriptionPackages, selectSubscriptionStatus } from '../../../../../Redux/Actions/Admin/ManageSubscriptionStatusActions';
import { fetchStates } from '../../../../../Redux/Actions/CommonActions'
import './ManageSubscriptions.scss'

class SubscriptionForm extends Component {
	constructor(props) {
		var data = {};
		if (!props.dataItem.MagazineSubscriptionId) {
			data.MagazineSubscriptionId = null;
		}
		else {
			let SubscriptionType = {
				id: props.dataItem.MagazineSubscriptionTypeId,
				description: props.dataItem.SubscriptionType
			}
			let SubscriptionStatus = {
				id: props.dataItem.MagazineSubscriptionStatusId,
				description: props.dataItem.SubscriptionStatus
			}
			let SubscriptionPackage = {
				id: props.dataItem.MagazineSubscriptionPackageId,
				description: props.dataItem.MagazineSubscriptionPackage
			}
			let State = {
				id: props.dataItem.StateId,
				name: props.dataItem.State,
				isActive: false
			}
			data.MagazineSubscriptionId = props.dataItem.MagazineSubscriptionId;
			data.magazineSubscriptionType = SubscriptionType;
			data.magazineSubscriptionStatus= SubscriptionStatus;
			data.subscriptionStartDate = props.dataItem.StartDate.substring(0, 10);
			data.subscriptionExpiresDate = props.dataItem.ExpirationDate.substring(0, 10);
			data.magazineSubscriptionPackage= SubscriptionPackage;
			data.firstName= props.dataItem.FirstName;
			data.lastName= props.dataItem.LastName;
			data.companyName= props.dataItem.CompanyName;
			data.preferredMailingName= props.dataItem.PreferredMailingName;
			data.mailingAddress1= props.dataItem.MailingAddress1;
			data.mailingAddress2= props.dataItem.MailingAddress2;
			data.mailingCity= props.dataItem.MailingCity;
			data.state= State;
			data.mailingZip= props.dataItem.MailingZip;
			data.email= props.dataItem.Email;
			data.phone= props.dataItem.Phone;
		}




        super(props);
		this.state = {
			subscriptionInEdit: data,
			value: [],
		};
	}

	componentDidMount() {
		this.props.fetchSubscriptionTypes();
        this.props.fetchSubscriptionStatuses();
        this.props.fetchSubscriptionPackages();
		this.props.fetchStates();
	}


	handleSubmit = (event) => {
		event.preventDefault();

		if (this.state.subscriptionInEdit.MagazineSubscriptionId) {
			this.props.save(this.state.subscriptionInEdit);
		} else {
			this.props.new(this.state.subscriptionInEdit);
		}
		this.props.cancel();
	};
	/*
	isCustom(item) {
		return item.id === undefined;
	}

	addKey(item) {
		item.id = new Date().getTime();
	}*/
	onWindowInputChange = (event) => {
        let target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.props ? target.props.name : target.name;

		const edited = this.state.subscriptionInEdit;
		edited[name] = value;
		edited.isActive = true;
		this.setState({
			subscriptionInEdit: edited
		});
    };

    handleSubscriptionTypeChange = (event) => {
        this.selectedSubscriptionType(event.target.value);
    }

	handleSubscriptionStatusChange = (event) => {
        this.selectedSubscriptionStatus(event.target.value);
    }

    handleSubscriptionPackageChange = (event) => {
        let value = event.target.value;
        let temp = this.state.subscriptionInEdit;
        temp.magazineSubscriptionPackage = value;
        this.setState({
            subscriptionInEdit: temp
        });
    }

	handleState = (event) => {
		const value = event.target.value;
		if (value !== null) {
            this.setState({ subscriptionInEdit: { ...this.state.subscriptionInEdit, state: value } });
        }
	};

    selectedSubscriptionStatus = (value) => {
        this.props.selectSubscriptionStatus(value);
        if (value !== null) {
            this.setState({ subscriptionInEdit: { ...this.state.subscriptionInEdit, magazineSubscriptionStatus: value } });
        }
	}

	selectedSubscriptionType = (value) => {
        this.props.selectSubscriptionType(value);
        if (value !== null) {
            this.setState({ subscriptionInEdit: { ...this.state.subscriptionInEdit, magazineSubscriptionType: value } });
        }
	}

	renderDropdowns = () => {
    	return (
    		<Fragment>
					<div className="form-group col-md-6 col-lg-2">
						<label htmlFor="MagazineSubscriptionId">Type</label>
						<DropDownList data={this.props.subscriptionType.subscriptionTypes}
													textField="description"
													dataItemKey="id"
													onChange={this.handleSubscriptionTypeChange}
													value={this.state.subscriptionInEdit.magazineSubscriptionType}
													allowCustom={false}
													filterable={false}
													clearButton={false}
													width={300}
													required={true}
													disabled={true}
						/>
					</div>
					<div className="form-group col-md-6 col-lg-3">
						<label htmlFor="subscriptionTypeId">Status</label>
						<DropDownList data={this.props.subscriptionStatus.subscriptionStatuses}
													textField="description"
													dataItemKey="id"
													onChange={this.handleSubscriptionStatusChange}
													value={this.state.subscriptionInEdit.magazineSubscriptionStatus}
													allowCustom={false}
													filterable={false}
													clearButton={false}
													width={300}
													required={true}
													disabled={true}
						/>
					</div>
					<div className="form-group col-md-6 col-lg-3">
						<label htmlFor="subscriptionStartDate">Start Date</label>
						<Input
							type="text"
							name="subscriptionStartDate"
							id="subscriptionStartDate"
							value={this.state.subscriptionInEdit.subscriptionStartDate || ''}
							onChange={this.onWindowInputChange}
							disabled={true}
						/>
					</div>
					<div className="form-group col-md-6 col-lg-4">
						<label htmlFor="subscriptionExpiresDate">Expiration Date</label>
						<Input
							type="text"
							name="subscriptionExpiresDate"
							id="subscriptionExpiresDate"
							value={this.state.subscriptionInEdit.subscriptionExpiresDate || ''}
							onChange={this.onWindowInputChange}
							disabled={true}
						/>
					</div>
					<div className="form-group col-md-6 col-lg-4">
						<label htmlFor="magazineSubscriptionPackage">Package</label>
						<DropDownList data={this.props.subscriptionStatus.subscriptionPackages}
													textField="description"
													dataItemKey="id"
													onChange={this.handleSubscriptionPackageChange}
													value={this.state.subscriptionInEdit.magazineSubscriptionPackage}
													allowCustom={false}
													filterable={false}
													clearButton={false}
													width={300}
													required={true}
													disabled={true}
						/>
					</div>
				</Fragment>
			)
	}

	render() {
		return (
			<div>
				{!this.state.subscriptionInEdit.MagazineSubscriptionId ?
						<h2 className="adjust-dist-title">Add New Subscription</h2> :
						<h2 className="adjust-dist-title">Edit Subscription</h2>}

				<form className="user-form" onSubmit={this.handleSubmit}>

					{!this.state.subscriptionInEdit.MagazineSubscriptionId ? null  : this.renderDropdowns()}
					<div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="firstName">First Name</label>
						<Input
							type="text"
							name="firstName"
							id="firstName"
							value={this.state.subscriptionInEdit.firstName || ''}
							onChange={this.onWindowInputChange}
						/>
					</div>
					<div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="lastName">Last Name</label>
						<Input
							type="text"
							name="lastName"
							id="lastName"
							value={this.state.subscriptionInEdit.lastName || ''}
							onChange={this.onWindowInputChange}
						/>
					</div>
					<div className="form-group col-md-6 col-lg-6">
                        <label htmlFor="companyName">Company Name</label>
						<Input
							type="text"
							name="companyName"
							id="companyName"
							value={this.state.subscriptionInEdit.companyName || ''}
							onChange={this.onWindowInputChange}
						/>
					</div>
					<div className="form-group col-md-6 col-lg-6">
                        <label htmlFor="preferredMailingName">Preferred Mailing Name</label>
						<Input
							type="text"
							name="preferredMailingName"
							id="preferredMailingName"
							value={this.state.subscriptionInEdit.preferredMailingName || ''}
							onChange={this.onWindowInputChange}
						/>
					</div>
					<div className="form-group col-md-6 col-lg-6">
                        <label htmlFor="mailingAddress1">Address 1</label>
						<Input
							type="text"
							name="mailingAddress1"
							id="mailingAddress1"
							value={this.state.subscriptionInEdit.mailingAddress1 || ''}
							onChange={this.onWindowInputChange}
						/>
					</div>
					<div className="form-group col-md-6 col-lg-6">
                        <label htmlFor="mailingAddress2">Address 2</label>
						<Input
							type="text"
							name="mailingAddress2"
							id="mailingAddress2"
							value={this.state.subscriptionInEdit.mailingAddress2 || ''}
							onChange={this.onWindowInputChange}
						/>
					</div>
					<div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="mailingCity">City</label>
						<Input
							type="text"
							name="mailingCity"
							id="mailingCity"
							value={this.state.subscriptionInEdit.mailingCity || ''}
							onChange={this.onWindowInputChange}
						/>
					</div>
					<div className="form-group col-md-6 col-lg-2">
					<label htmlFor="State" className="">State</label>
						<DropDownList data={this.props.common.states}
							dataItemKey="id"
							textField="name"
							onChange={this.handleState}
							value={this.state.subscriptionInEdit.state}
							allowCustom={false}
							filterable={false}
							clearButton={false}
							width={300}
							required={true}
							name="State"
							id="State"
						/>
					</div>
					<div className="form-group col-md-6 col-lg-2">
                        <label htmlFor="mailingZip">Zip</label>
						<Input
							type="text"
							name="mailingZip"
							id="mailingZip"
							value={this.state.subscriptionInEdit.mailingZip || ''}
							onChange={this.onWindowInputChange}
						/>
					</div>
					<div className="form-group col-md-6 col-lg-4">
                        <label htmlFor="email">Email</label>
						<Input
							type="text"
							name="email"
							id="email"
							value={this.state.subscriptionInEdit.email || ''}
							onChange={this.onWindowInputChange}
						/>
					</div>
					<div className="form-group col-md-6 col-lg-3">
                        <label htmlFor="phone">Phone</label>
						<Input
							type="text"
							name="phone"
							id="phone"
							value={this.state.subscriptionInEdit.phone || ''}
							onChange={this.onWindowInputChange}
						/>
					</div>

					<DialogActionsBar>
						<div className="adjust-btns">
							<div className="form-group">
								<button className="admin-k-button" onClick={this.props.cancel}>
									<i className="fas fa-times"></i>
									<span>CANCEL</span>
								</button>
								{!this.state.subscriptionInEdit.MagazineSubscriptionId ? (
									<button type="submit" className="admin-k-button">
										<i className="fas fa-save"></i>
										<span>SAVE</span>
									</button>
								) : (
									<button type="submit" className="admin-k-button">
										<i className="fas fa-edit"></i>
										<span>UPDATE</span>
									</button>
								)}
							</div>
						</div>
					</DialogActionsBar>
				</form>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		subscription: state.adminSubscription,
		common: state.common,
		subscriptionType: state.subscriptionType,
		subscriptionStatus: state.subscriptionStatus,
	};
}

export default connect(mapStateToProps, {
	fetchSubscriptionTypes,
    fetchSubscriptionStatuses,
    fetchSubscriptionPackages,
	fetchStates,
	selectSubscriptionType,
	selectSubscriptionStatus,
}) (SubscriptionForm);
